var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "el-dialog2 hiddenScrollbar",
      staticStyle: {
        "margin-right": "50%",
        width: "760px",
        "overflow-y": "inherit",
        "margin-left": "0.6rem",
        "margin-top": "0 !important",
        top: "45% !important",
        transform: "translateY(-50%)",
        height: "910px",
      },
      attrs: {
        "append-to-body": true,
        modal: false,
        visible: _vm.dialogVisible,
        "destroy-on-close": true,
        width: "80%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _vm.showButton
        ? _c(
            "div",
            { staticStyle: { position: "sticky", bottom: "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.emitSave },
                },
                [_vm._v("立即保存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "lineBox hiddenScrollbar",
          staticStyle: {
            "overflow-y": "scroll",
            position: "relative",
            height: "910px",
          },
          style: { height: _vm.getHeight },
        },
        [
          _c("Tinymce", {
            key: _vm.brush,
            staticStyle: { "margin-top": "10px" },
            attrs: { "display-mode": _vm.displayMode, height: 700 },
            model: {
              value: _vm.datas,
              callback: function ($$v) {
                _vm.datas = $$v
              },
              expression: "datas",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }